import { PublicClientApplication } from '@azure/msal-browser';

// Microsoft sign-in (popup + silent-token iframe) must redirect to a dedicated
// INERT page, NEVER the SPA root. If the popup lands on the SPA root, App.vue's
// mounted hook calls `$router.push(...)` and strips the auth-code hash before
// MSAL (running in the opener) can read it — causing
// `BrowserAuthError: monitor_window_timeout` (SmileBAR Safari failure,
// 2026-06-16). The blank page lives at public/auth-blank.html and loads no
// JS/router, so it cannot strip the hash or navigate away.
//
// IMPORTANT: this redirectUri must be registered as a *SPA* redirect URI on the
// Azure app registration for every origin we serve from
// (http://localhost:8080, https://dev.teamio.app, https://prod.teamio.app) or
// Microsoft rejects sign-in with AADSTS50011 (redirect URI mismatch).
//
// KEEP IN SYNC WITH the mirrored copy in
// cypress/node-tests/msal-popup-redirect.test.js.
export function buildRedirectUri(origin) {
  const base = String(origin || '').replace(/\/+$/, '');
  return `${base}/auth-blank.html`;
}

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MICROSOFT_CLIENT_ID || 'YOUR_MICROSOFT_CLIENT_ID', // Replace with your Microsoft App Registration Client ID
    authority: process.env.VUE_APP_MICROSOFT_AUTHORITY || 'https://login.microsoftonline.com/common',
    redirectUri: buildRedirectUri(window.location.origin), // inert /auth-blank.html — see note above
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 'Error':
            console.error(message);
            return;
          case 'Info':
            console.info(message);
            return;
          case 'Verbose':
            console.debug(message);
            return;
          case 'Warning':
            console.warn(message);
            return;
        }
      }
    }
  }
};

// Add scopes here for ID token to be used at Microsoft Graph API endpoints.
export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
  prompt: 'select_account'
};

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
export const initializeMsal = async () => {
  await msalInstance.initialize();
  
  // Handle redirect promise
  try {
    const response = await msalInstance.handleRedirectPromise();
    if (response) {
      console.log('MSAL redirect response:', response);
      return response;
    }
  } catch (error) {
    console.error('MSAL redirect error:', error);
    throw error;
  }
  
  return null;
};
